import { useQuery } from "@tanstack/react-query";
import { statsRepo } from "@/lib/repositories";
import type { ActiveUsersStatParams } from "../types";

export function useFetchActiveUsers({
  end_date,
  start_date,
  status,
  active,
  x_period,
}: ActiveUsersStatParams) {
  const query = useQuery({
    queryKey: [
      "stats",
      "active-users",
      { end_date, start_date, status, active, x_period },
    ],
    queryFn: () =>
      statsRepo.fetchActiveUsers({
        end_date,
        start_date,
        status,
        active,
        x_period,
      }),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
  };
}
